import { useState, useEffect, useRef } from 'react';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useTranslation } from 'react-i18next';
// material
import { Box, Backdrop, Paper, Tooltip, Divider, Typography, Stack, Avatar, Grid, IconButtonm, Popover, TextField, Button, LinearProgress, Card, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
//
import { MIconButton } from '../@material-extend';
import Lottie from 'react-lottie';
import callingGif from './gifLottie/calling.json'
import IncomingCall from './IncomingCall';
import OutgoingCall from './OutgoingCall';
import CounterUp from './TimeCalling';
import './css/CircularButton.css';
import { useSelector } from '../../redux/store';
import MenuPopover from '../MenuPopover';
import { ContentPasteSearchOutlined } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandDialPadDtmf from './ExpandDialPadDtmf';
import apiContact from '../../api/contact';
import { useSnackbar } from 'notistack5';
import FormActionContact2 from '../../pages/ActionContact/FormActionContact2';
import useAuth from '../../hooks/useAuth';
import Scrollbar from '../Scrollbar';
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 400;

export default function Calling() {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { calling, infoContact, outGoingCall, incomingCall, answered, doHangup, doDecline, doAnswer, toggleMute, toggleHold, transfer, isHold, isMuted, isTransfer } = useSelector(state => state.janus);
  const { user } = useAuth();
  const [showIncomingCall, setShowIncomingCall] = useState(incomingCall);
  const [showOutgoingCall, setShowOutgoingCall] = useState(outGoingCall);
  const [isRunning, setIsRunning] = useState(true);
  const [open, setOpen] = useState(calling);
  const [openPopoverOrther, setOpenPopoverOrther] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const anchorRef = useRef(null);
  const anchorRefOrther = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [numberTransfer, setNumberTransfer] = useState();
  const [infoIncomingCall, setInfoIncomingCall] = useState([]);
  const [contentNote, setContentNote] = useState("");
  const [checkWriteNote, setCheckWriteNote] = useState("");
  const [isShowAddContactOnSelect, setIsShowAddContactOnSelect] = useState(false);
  const [isRefreshContact, setIsRefreshContact] = useState(false);
  const [isTransferUser, setIsTransferUser] = useState(null);
  const handleAnswer = () => {
    console.log('Answered call');
    setShowIncomingCall(false);
    //setanswered(true);

  };
  const handleReject = () => {
    console.log('Rejected call');
    // setShowIncomingCall(false);
  };

  const getInfoContactByPhone = async (phone) => {
    try {
      const res = await apiContact.check_customer_other({ phone: phone });
      console.log(res.data.data);
      if (res && res.status == 200) {
        setInfoIncomingCall({ name: res.data.data.name, phone: phone, data_info: res.data.data });
        setContentNote(res.data.data.notes);
      } else { setInfoIncomingCall({ name: "", phone: phone }); }
    } catch (error) {
      console.log(error.res.data.message[0]);
      setInfoIncomingCall({ name: "", phone: phone });
    }
  }

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [open]);
  useEffect(() => {
    setCheckWriteNote("");
    if (showIncomingCall) {

    } else {
      setContentNote(infoContact?.notes);
    }
  }, [showIncomingCall]);

  useEffect(() => {
    if (showIncomingCall && infoContact?.phone) {
      getInfoContactByPhone(infoContact?.phone);
    } else {
      //getInfoContact();
    }
  }, [isRefreshContact, infoContact?.phone]);
  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: callingGif,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  const callerAvatar = "https://randomuser.me/api/portraits/men/832130.jpg";
  const handleOpenTransfer = () => {
    setOpenPopover(!openPopover);
  };

  const handleOpenTransferOrther = () => {
    setOpenPopoverOrther(!openPopoverOrther);
    setNumberTransfer(infoContact?.data_info?.sip_transfer);
  };

  const handleTransferOrther = async (numberTransferOrther) => {
    await doAnswer();
    // setIsTransferUser(numberTransferOrther);
    setTimeout(
      () => transfer(numberTransferOrther),
      1500
    );
  };


  const handleTransfer = () => {
    transfer(numberTransfer);
  };

  const handleClosePopover = () => {
    setOpenPopover(false);
  };

  const handleClosePopoverOrther = () => {
    setOpenPopoverOrther(false);
  };
  const handleWritingNote = async () => {
    try {
      const writeNote = await apiContact.write_note_calling({ phone: infoContact?.phone, extend: user?.sip_selected, content: contentNote });
      if (writeNote.status == 200) {
        enqueueSnackbar("Cập nhật ghi chú thành công!", { variant: 'success' });
        setCheckWriteNote(true);
        setContentNote("");
      }
    } catch (e) {
      enqueueSnackbar(e.response.data.message[0], { variant: 'error' });
      setCheckWriteNote(false);
    }
  }
  const handleStatusWriteNotes = () => {
    if (checkWriteNote !== "") {
      if (checkWriteNote) {
        return (
          <><Typography variant="subtitle2" sx={{ color: "#30DC75" }}>Cập nhật thành công !</Typography></>
        );
      } else {
        return (
          <><Typography variant="subtitle2" sx={{ color: "#EE4036" }}>Cập nhật thất bại !</Typography></>
        );
      }
    } else {
      return (<></>);
    }
  }
  const handleGetValueNote = (event) => {
    setContentNote(event.target.value)
  }
  const handleAddContact = () => {
    setIsShowAddContactOnSelect(prev => !prev);
    handleClose();
  };
  const handleCloseAddContact = () => {
    setIsShowAddContactOnSelect(false);
  };
  console.log(infoIncomingCall.length);
  return (
    <>

      {/* <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} onClick={handleClose} /> */}

      <Box
        sx={{
          top: 12,
          bottom: 12,
          right: 0,
          position: 'fixed',
          zIndex: 2002,
          ...(open && { right: 12 })
        }}
      >
        <Box
          sx={{
            p: 0.5,
            px: '4px',
            mt: 0,
            left: -44,
            top: '40%',
            color: 'grey.800',
            position: 'absolute',
            bgcolor: 'common.white',
            borderRadius: '24px 0 16px 24px',
            boxShadow: (theme) => theme.customShadows.z12
          }}
        >
          <Tooltip title="Calling">
            <MIconButton
              color="inherit"
              onClick={handleToggle}
              sx={{
                p: 0,
                width: 40,
                height: 40,
                transition: (theme) => theme.transitions.create('all'),
                '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
              }}
            >
              <Lottie options={defaultOptions}
                height={40}
                width={40} />
            </MIconButton>
          </Tooltip>
        </Box>

        <Paper
          sx={{
            height: 1,
            width: '0px',
            overflow: 'hidden',
            boxShadow: (theme) => theme.customShadows.z24,
            transition: (theme) => theme.transitions.create('width'),
            ...(open && { width: DRAWER_WIDTH }),
            backgroundImage: 'url(https://dev-api-multichannel.voip24h.vn/public/images/popup-dialing.svg)',
            backgroundSize: 'cover', // or 'contain'
          }}
        >
          <Scrollbar>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ py: 2, pr: 1, pl: 2.5 }}>
              <MIconButton onClick={handleClose}>
                <Icon icon={closeFill} width={20} height={20} />
              </MIconButton>
            </Stack>
            <Divider />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem' }}>
              <Avatar src={callerAvatar} sx={{ width: 100, height: 100, marginBottom: '1rem' }} />
              <Stack direction={'column'} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Stack direction={'row'} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Typography variant="h5" align="center" gutterBottom sx={{ color: 'white' }}>
                    {/* {infoContact?.name} */}
                    {showIncomingCall ? infoIncomingCall?.name !== "" ? infoIncomingCall?.name : "" : infoContact?.name !== "" ? infoContact?.name : ""}
                  </Typography>
                  {showIncomingCall ? infoIncomingCall?.length === 0 ? <MIconButton onClick={() => handleAddContact()} sx={{ mt: '-8px' }}><Icon icon="mingcute:user-add-fill" width="24px" height="24px" color="#d1f0d9" /></MIconButton>
                    : null
                    : infoContact?.name === "" ? <MIconButton onClick={() => handleAddContact()} sx={{ mt: '-8px' }}><Icon icon="mingcute:user-add-fill" width="24px" height="24px" color="#d1f0d9" /></MIconButton> : null}
                </Stack>
                {infoIncomingCall?.length === 0 ? null : <Button variant='contained' startIcon={<Icon icon="charm:forward" />} onClick={() => handleOpenTransferOrther()} ref={anchorRefOrther} >Nhân viên: {infoIncomingCall?.data_info?.assigned_by_name}</Button>}
                {infoIncomingCall?.length === 0 ? null : <MenuPopover sxPopover={{ sx: { zIndex: 3005 } }} open={openPopoverOrther} onClose={handleClosePopoverOrther} anchorEl={anchorRefOrther.current} sx={{ p: 1, width: 300 }}>
                  {!isTransfer ? <Stack direction={"column"} spacing={1}>
                    <Typography variant='h6'>Cuộc gọi sẽ chuyển đến số {infoIncomingCall?.data_info?.sip_transfer} của nhân viên {infoIncomingCall?.data_info?.assigned_by_name}...</Typography>
                    <Button color='success' variant='outlined' onClick={() => handleTransferOrther(infoIncomingCall?.data_info?.sip_transfer)}>
                      Đồng ý
                    </Button>
                  </Stack> : <><Typography variant='h6'>Cuộc gọi đang chuyển đến số {infoIncomingCall?.data_info?.sip_transfer}...</Typography><LinearProgress color="success" /></>}
                </MenuPopover>}
              </Stack>
              <Typography align="center" gutterBottom sx={{ color: 'white', mt: "2px" }}>
                {showIncomingCall && (t('incoming_call'))}
                {showOutgoingCall && (t('outgoing_call'))}
              </Typography>
              {answered || isRunning == false ? <CounterUp isRunning={isRunning} /> : null}
              <Typography align="center" gutterBottom sx={{ color: 'white' }}>
                {infoContact?.phone}
              </Typography>
            </div>
            {answered == true ? <Stack direction={"row"} justifyContent={'center'} spacing={5}>
              <button className="circular-button" onClick={() => toggleHold()}>
                <Icon className="icon" icon={isHold ? "material-symbols:play-arrow" : "material-symbols:pause-rounded"} />
              </button>
              <button className="circular-button" onClick={() => toggleMute()}>
                <Icon className="icon" icon={isMuted ? "bi:mic-fill" : "bi:mic-mute-fill"} />
              </button>
              <button className="circular-button" onClick={() => handleOpenTransfer()} ref={anchorRef} >
                <Icon className="icon" icon="mingcute:transfer-3-fill" />
              </button>
              <MenuPopover sxPopover={{ sx: { zIndex: 3005 } }} open={openPopover} onClose={handleClosePopover} anchorEl={anchorRef.current} sx={{ p: 1, width: 300 }}>
                {!isTransfer ? <Stack direction={"row"} spacing={1}>
                  <TextField label={"Chuyển tiếp cuộc gọi đến"} type='number' onChange={(e) => setNumberTransfer(e.target.value)}></TextField>
                  <Button color='success' variant='outlined' onClick={() => handleTransfer()}>
                    {<Icon icon="solar:transfer-horizontal-bold" width="36" />}
                  </Button>
                </Stack> : <><Typography variant='h6'>Cuộc gọi đang chuyển đến số {numberTransfer}...</Typography><LinearProgress color="success" /></>}
              </MenuPopover>
            </Stack> : null}
            {answered == true ? <Stack sx={{ mt: 2 }} direction={"row"} justifyContent={'center'} spacing={5}>
              <ExpandDialPadDtmf />
            </Stack> : null}

            {showIncomingCall && (
              <IncomingCall
                onAnswer={doAnswer}
                onReject={doDecline}
                onHangup={doHangup}
                answered={answered}
              />
            )}
            <div class="hide" id="audiostream"></div>
            {showOutgoingCall ?
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <MIconButton onClick={doHangup}>
                  <OutgoingCall />
                </MIconButton>
              </Box>
              : null}
            {(answered || isRunning == false) && (infoIncomingCall?.length !== 0 || infoContact?.name !== "") ? <Stack direction={"row"} justifyContent={'center'} sx={{ p: 2 }}>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Stack direction="row">
                    <Typography>Ghi chú:</Typography>
                    <div style={{ margin: "1px" }}>{handleStatusWriteNotes()}</div>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <TextField
                    fullWidth
                    label="Ghi chú cuộc gọi"
                    multiline
                    // defaultValue={contentNote}
                    onChange={(e) => handleGetValueNote(e)}
                  />
                  <Button onClick={() => handleWritingNote()} variant="contained" sx={{ color: "#fff", backgroundColor: "#54D62C", mt: "5px" }} justifyContent={'flex-end'} startIcon={<Icon icon="fluent-mdl2:edit-note" />}>Cập nhật ghi chú</Button>
                </AccordionDetails>
              </Accordion>
            </Stack> : null}
          </Scrollbar>
        </Paper>
        {isShowAddContactOnSelect && <FormActionContact2
          infoContact={[]}
          type={'quick_callhistory'}
          participants={[]}
          phoneNumberSelect={infoContact?.phone}
          setIsRefreshContact={setIsRefreshContact}
          isOpen={isShowAddContactOnSelect}
          onClose={handleCloseAddContact}
          onDeleteTask={() => { }}

        />
        }
      </Box >
    </>
  );
}
